import React ,{useState}from "react";
import "./downloadBarIcon.css"
import { useSelector,useDispatch } from "react-redux";
import SandClockUrl from "../../assets/gif/sandClock.gif";
import { setShowDownload } from "../../stateManagement/actions/downloadBarActions";
import { downloadBarIcon } from "../../types/types";
import {  Tooltip } from "@mui/material";
import Draggable from "react-draggable";
const DownloadBarIcon=(props:downloadBarIcon)=>{
    const showDownload=useSelector((state: any) => state.downloadBarReducer.showDownload);
    const [isDragging, setIsDragging] = useState<boolean>(false);
     const [hasDragged, setHasDragged] = useState<boolean>(false);
    const dispatch=useDispatch();
    const handleDragStart = () => {
        setIsDragging(true);
        setHasDragged(false); 
    };

    const handleDrag = () => {
        setIsDragging(true);
        setHasDragged(true); 
    };

    const handleClick = () => {
        if (!hasDragged) {
            dispatch(setShowDownload(true));
        }
    };

    const handleDragStop = () => {
        setIsDragging(false);
        setTimeout(() => {
            setHasDragged(false);
        }, 50);
    };
    return(
      
         <Draggable 
         onStart={handleDragStart}
        onDrag={handleDrag}
        onStop={handleDragStop}
            bounds={(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const horizontalLimit = width > 1440 ? -1200 : -1075;  
    const verticalLimit = height > 900 ? -685 : -610;
    return props.isPasswordSet
      ? { left: horizontalLimit, top: verticalLimit, right: 0, bottom: 0 }
      : { left: horizontalLimit-6, top: 0, right: 0, bottom: height > 900 ? 675 : 600 };
  })()}
   >
       <Tooltip title="Downloads in progress - view status" placement="left">
       
    <div  className={
      (props.isPasswordSet
        ? "download-bar-icon-container-config"
        : "download-bar-icon-container") +
      (isDragging ? " dragging-cursor" : "")
    } 
          onClick={handleClick}>
        <img
            src={SandClockUrl}
            alt="Loading"
            className="loading-spinner-icon"
     />
    </div>
    
    </Tooltip>
    </Draggable>
    )
};
export default DownloadBarIcon;